import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type { ResourceType } from 'types/resource-types';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function createViewFn(
  axiosInstance: Promise<AxiosInstance>,
  { resourceType }: { resourceType: ResourceType }, // todo: estract to variables
): Promise<ApiResponse> {
  const instance = await axiosInstance;

  return instance.post(`views/${resourceType}`);
}

export function useCreateView() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, { resourceType: ResourceType }>({
    mutationFn: variables => createViewFn(axiosInstance, variables),
    onSuccess: (_response, { resourceType }) => {
      client.invalidateQueries({
        queryKey: ['views', resourceType],
      });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    { resourceType: ResourceType },
    'createView'
  >('createView', mutation);
}
